import { Link } from '@reach/router';
import { useFormikContext } from 'formik';
import React from 'react';
import { deepGet } from 'utils/form';
import { ErrorM } from './ErrorM';

interface FormCheckboxFieldProps {
  field: string;
  label?: string;
  labelLinkText?: string;
  labelLinkHref?: string;
  onlyOneOptionSelected?: () => void;
}

const FormCheckboxField = function <T>({
  field,
  label,
  labelLinkText,
  labelLinkHref,
  onlyOneOptionSelected,
}: FormCheckboxFieldProps) {
  const formikContext = useFormikContext<T>();
  return (
    <div className="FormBox">
      <div className="Checkbox">
        <input
          name={field}
          type="checkbox"
          id={field}
          checked={deepGet(formikContext.values, field)}
          onChange={(e) => {
            formikContext.setFieldValue(
              field as any,
              !deepGet(formikContext.values, field)
            );
            onlyOneOptionSelected && onlyOneOptionSelected();
          }}
        />
        {label && (
          <label className="CustomInput" htmlFor={field}>
            {labelLinkText && labelLinkHref ? (
              <Link to={labelLinkHref}>{label}</Link>
            ) : (
              label
            )}
          </label>
        )}
        <ErrorM name={field} />
      </div>
    </div>
  );
};

export { FormCheckboxField };
